import React, { Component } from 'react';
import dates from './utils/dates';
import localizer from './localizer';
import { navigate } from './utils/constants';
import TimeGrid from './TimeGrid';

class Week extends Component {

  static propTypes = TimeGrid.propTypes;
  static defaultProps = TimeGrid.defaultProps;

  render() {
    const { date, events, startAccessor, onSelectEvent } = this.props; // Added onSelectEvent
    const { start, end } = Week.range(date, this.props);

    return (
      <TimeGrid 
        {...this.props} 
        start={start} 
        end={end} 
        eventOffset={15} 
        onSelectEvent={onSelectEvent} // Pass onSelectEvent down
      />
    );
  }
}

Week.navigate = (date, action) => {
  switch (action) {
    case navigate.PREVIOUS:
      return dates.add(date, -1, 'week');

    case navigate.NEXT:
      return dates.add(date, 1, 'week');

    default:
      return date;
  }
};

Week.range = (date, { culture }) => {
  const firstOfWeek = localizer.startOfWeek(culture);
  const start = dates.startOf(date, 'week', firstOfWeek);
  // Use end-of-day for the last week day so late Saturday events are included.
  const weekEnd = dates.endOf(date, 'week', firstOfWeek);
  const end = dates.endOf(weekEnd, 'day');

  return { start, end };
};

export default Week;